import actions from '~/store/modules/shared/classifieds/search/actions/actions'
import mutations from '~/store/modules/shared/classifieds/search/actions/mutations'
import state from '~/store/modules/shared/classifieds/search/actions/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  mutations,
  state
})
